/**
 * 过户管理
 */
import Mock from 'mockjs'
import cache from '../../common/cache'

// mock 开关
let mock = cache.getSessionData('mock')
let mockSwitch = mock ? '' : '_'

/**
 * 过户管理列表
 */
Mock.mock(/auctions\/car_transfers/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    total: 30,
    total_page: 2,
    orders: [
      {
        'order_type': 1,
        'order_id': 1,
        'id': 1,
        'freeze_status': 1,
        'transfer_status': 1,
        'auction_car': {
          'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
          'car_image_url': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg',
          'vin': 'LHGGK5854F2043183',
          'plate_number': '粤B22365'
        }
      },
      {
        'order_type': 1,
        'order_id': 1,
        'id': 2,
        'freeze_status': 2,
        'transfer_status': 2,
        'auction_car': {
          'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
          'car_image_url': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg',
          'vin': 'LHGGK5854F2043183',
          'plate_number': '粤B22365'
        }
      },
      {
        'order_type': 1,
        'order_id': 1,
        'id': 3,
        'freeze_status': 1,
        'transfer_status': 1,
        'auction_car': {
          'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
          'car_image_url': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg',
          'vin': 'LHGGK5854F2043183',
          'plate_number': '粤B22365'
        }
      },
      {
        'order_type': 1,
        'order_id': 1,
        'id': 4,
        'freeze_status': 1,
        'transfer_status': 1,
        'auction_car': {
          'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
          'car_image_url': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg',
          'vin': 'LHGGK5854F2043183',
          'plate_number': '粤B22365'
        }
      },
      {
        'order_type': 1,
        'order_id': 1,
        'id': 5,
        'freeze_status': 2,
        'transfer_status': 2,
        'auction_car': {
          'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
          'car_image_url': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg',
          'vin': 'LHGGK5854F2043183',
          'plate_number': '粤B22365'
        }
      }
    ]
  }
})

/**
 * 过户资料
 */
Mock.mock(/auctions\/car_transfer\/detail/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'transferor_name': '张三',
    'dealer_user_mobile': 11111111,
    'transfer_note': '这个车商信誉度很高',
    'transfer_status': 2, // 1未过户 2已过户
    'freeze_status': 1, // 1未解冻 2已解冻
    'images': [
      {
        'type': 'transfer_ticket',
        'url': 'https://www.baidu.com/img/bd_logo1.png'
      },
      {
        'type': 'other_1',
        'url': 'https://www.baidu.com/img/bd_logo1.png'
      }
    ]
  }
})

/**
* 解冻保证金
*/
Mock.mock(/auctions\/car_transfer\/unfreeze/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})

/**
 * 确认过户
 */
Mock.mock(/auctions\/car_transfer/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})
